import { DASHBOARD } from "@constants/internal-route.constant";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

type PageHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  /** After "Home"; the last one is the current page. */
  crumbs?: Crumb[];
};

/** Title on the left, breadcrumb on the right. Page actions never go here: they sit in the
 *  top-right of the card they act on (list: Export…, then Create last). */
export const PageHeader = ({ title, subtitle, crumbs = [] }: PageHeaderProps) => (
  <div className="app-content-header">
    <div className="container-fluid">
      <div className="row align-items-center g-2">
        <div className="col-sm-7 min-w-0">
          <h3 className="mb-0 text-truncate">{title}</h3>
          {subtitle ? <div className="text-body-secondary small mt-1">{subtitle}</div> : null}
        </div>
        <div className="col-sm-5">
          <ol className="breadcrumb float-sm-end mb-0">
            <li className="breadcrumb-item">
              <Link to={DASHBOARD}>Home</Link>
            </li>
            {crumbs.map((c, i) =>
              i === crumbs.length - 1 ? (
                <li key={i} className="breadcrumb-item active" aria-current="page">
                  {c.label}
                </li>
              ) : (
                <li key={i} className="breadcrumb-item">
                  {c.to ? <Link to={c.to}>{c.label}</Link> : c.label}
                </li>
              )
            )}
          </ol>
        </div>
      </div>
    </div>
  </div>
);

type ConsolePageProps = PageHeaderProps & { children: ReactNode };

/** An AdminLTE console page: the content header, then the content. Pages built on this are
 *  listed in app.routes.ts. */
const ConsolePage = ({ children, ...header }: ConsolePageProps) => (
  <>
    <PageHeader {...header} />
    <div className="app-content">
      <div className="container-fluid">{children}</div>
    </div>
  </>
);

export default ConsolePage;
